import "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import { default as h } from "./index.es16.js";
import { default as b } from "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import { default as C } from "./index.es19.js";
import { default as Z } from "./index.es20.js";
import { default as v } from "./index.es21.js";
import { default as B } from "./index.es22.js";
import { default as R } from "./index.es23.js";
import { default as w } from "./index.es24.js";
import { default as E } from "./index.es25.js";
import "./index.es26.js";
import { default as J } from "./index.es29.js";
import { default as M } from "./index.es30.js";
import { default as P } from "./index.es31.js";
import "./index.es32.js";
const c = (o) => o && o.replaceAll(/ø/gi, "o").replaceAll(/æ/gi, "ae").replaceAll(/å/gi, "aa").match(
  /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
)?.join("-")?.toLowerCase() || "", x = "bufdir:hash:navigate";
export {
  P as AccordionsGroup,
  M as BlockAccordions,
  E as ChartJsChart,
  R as MultiChoice,
  B as PageTitle,
  w as RadioGroup,
  b as RichText,
  h as SingleSelect,
  Z as Spinner,
  C as SpinnerBlock,
  J as StatisticsTable,
  v as TypeAhead,
  x as bufdirHashNavigateEvent,
  c as kebabCase
};
//# sourceMappingURL=index.es7.js.map
